import React from 'react';

import CalendarDropdown from './CalendarDropdown';
import { makeGetTaskById } from '../../../../redux/tasks/taskEntities/selectors';
import { connect } from 'react-redux';

const TaskCalendarDropdownWrapper = ({ taskId, ...rest }) => (
  <CalendarDropdown {...rest} />
);

const makeMapStateToProps = () => {
  const getTaskById = makeGetTaskById();

  return (state, ownProps) => ({
    task: getTaskById(state, ownProps)
  });
};

export default connect(makeMapStateToProps)(TaskCalendarDropdownWrapper);
